import {
  withTranslation,
} from 'react-i18next';

import RegionFieldsView from './RegionFieldsView';

const TranslatedComponent = withTranslation()(RegionFieldsView);

const Component = TranslatedComponent;

export default Component;
